module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.L.localize('Members_ChangeGroup')))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "form js-form"
  }, [_c('submenu'), _vm._v(" "), _c('div', {
    staticClass: "options-list"
  }, _vm._l((_vm.groups), function(group) {
    return _c('div', {
      staticClass: "options-list__item"
    }, [_c('div', {
      staticClass: "options-list__content"
    }, [_c('h2', {
      staticClass: "options-list__title"
    }, [_vm._v(_vm._s(group.name))])]), _vm._v(" "), _c('div', {
      staticClass: "options-list__control",
      attrs: {
        "data-acc": _vm.acc.generate('toggle', group.name)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentGroups),
        expression: "currentGroups"
      }],
      staticClass: "options-list__checkbox",
      attrs: {
        "type": "checkbox",
        "data-acc": _vm.acc.generate('input', group.name),
        "id": group.id
      },
      domProps: {
        "value": group.id,
        "checked": Array.isArray(_vm.currentGroups) ? _vm._i(_vm.currentGroups, group.id) > -1 : (_vm.currentGroups)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(group.id)
        },
        "change": function($event) {
          var $$a = _vm.currentGroups,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = group.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.currentGroups = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.currentGroups = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.currentGroups = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "options-list__toggle",
      attrs: {
        "for": group.id
      }
    })])])
  }), 0)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-444ad46c!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/members/MemberChangeGroup.vue
// module id = 730
// module chunks = 1